module.exports = __webpack_public_path__ + "img/y- (10).a3ebbb45.png";